import cx from 'classnames';
import { IconButton } from '@fashionnovateam/nova-ui-toolkit';
import { PrintOutlined } from '@mui/icons-material';
import styles from './PrinterConfigurationButtonStatus.module.css';

interface PrinterConfigurationButtonProps {
  printersSet: boolean;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

function PrinterConfigurationButton({
  printersSet,
  onClick,
}: PrinterConfigurationButtonProps) {
  return (
    <div className={styles.printerConfigButtonContainer}>
      <IconButton
        icon={<PrintOutlined className={styles.printerConfigButtonIcon} />}
        label="Open printer configuration"
        color="secondary"
        onClick={onClick}
      />
      <div
        className={cx({
          [styles.printerConfigButtonStatusBase]: true,
          [styles.printerConfigButtonStatusMissing]: printersSet === false,
          [styles.printerConfigButtonStatusFilled]: printersSet === true,
        })}
      />
    </div>
  );
}

export default PrinterConfigurationButton;
